/** XeAgents.ai**/
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { StepCard, Field } from "./StepCard";

/** The languages the agent can be asked to speak. */
export const VOICE_LANGUAGES = [
  { code: "en", name: "English (US)" },
  { code: "hi-IN", name: "Hindi (हिन्दी)" },
  { code: "ta-IN", name: "Tamil (தமிழ்)" },
  { code: "te-IN", name: "Telugu (తెలుగు)" },
  { code: "kn-IN", name: "Kannada (ಕನ್ನಡ)" },
  { code: "ml-IN", name: "Malayalam (മലയാളം)" },
  { code: "mr-IN", name: "Marathi (मराठी)" },
  { code: "bn-IN", name: "Bengali (বাংলা)" },
  { code: "gu-IN", name: "Gujarati (ગુજરાતી)" },
  { code: "pa-IN", name: "Punjabi (ਪੰਜਾਬੀ)" },
  { code: "es", name: "Spanish (Español)" },
  { code: "fr", name: "French (Français)" },
  { code: "de", name: "German (Deutsch)" },
  { code: "pt", name: "Portuguese (Português)" },
  { code: "ar", name: "Arabic (العربية)" },
];

/** Two short fields, side by side. Deliberately the smallest card on the page. */
export function BasicSettings({
  name,
  onNameChange,
  onNameBlur,
  nameError,
  language,
  onLanguageChange,
}: {
  name: string;
  onNameChange: (value: string) => void;
  onNameBlur: () => void;
  nameError?: string;
  language: string;
  onLanguageChange: (value: string) => void;
}) {
  return (
    <StepCard step={1} title="Basic Settings" description="Name this template and choose the language the agent speaks.">
      <div className="grid gap-5 sm:grid-cols-2">
        <Field
          label="Template Name"
          htmlFor="template-name"
          required
          hint="For your reference — customers never hear it."
          error={nameError}
        >
          <Input
            id="template-name"
            value={name}
            onChange={(event) => onNameChange(event.target.value)}
            onBlur={onNameBlur}
            placeholder="B2B Sales Pitch"
            aria-invalid={!!nameError}
            data-testid="input-template-name"
          />
        </Field>

        <Field
          label="Voice Language"
          htmlFor="voice-language"
          required
          hint="The agent uses this for the entire conversation."
        >
          <Select value={language} onValueChange={onLanguageChange}>
            <SelectTrigger id="voice-language" data-testid="select-voice-language">
              <SelectValue placeholder="Select language" />
            </SelectTrigger>
            <SelectContent>
              {VOICE_LANGUAGES.map((option) => (
                <SelectItem key={option.code} value={option.code}>
                  {option.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </Field>
      </div>
    </StepCard>
  );
}
